import CityPage from '../../components/CityPage';

const cityData = {
    name: "Auberville",
    slug: "auberville",
    postalCode: "14640",
    intro: "Besoin d'un débarras à Auberville ? CC Débarras 14 intervient dans cette commune de la Côte Normande pour vider vos biens rapidement et dans le respect de votre logement. Auberville fait partie de notre zone d'action entre Villers-sur-Mer et Houlgate. Maisons, résidences secondaires, caves : nous nous chargeons de tout le débarras, que la situation soit urgente ou planifiée.",
    nearby: ["Villers-sur-Mer", "Houlgate", "Blonville-sur-Mer", "Dives-sur-Mer", "Bénerville-sur-Mer"],
};

const Auberville = () => <CityPage city={cityData} />;

export default Auberville;
